'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext } from 'react';
import { EarlyPreviewBanner } from '@/components/EarlyPreviewBanner';
import { useDismissible } from '@/lib/hooks/useDismissible';
const BANNER_DISMISSED_KEY = 'sizzle-early-preview-banner-dismissed';
interface EarlyPreviewContextValue {
  isVisible: boolean;
  dismiss: () => void;
}
const EarlyPreviewContext = createContext<EarlyPreviewContextValue>({
  isVisible: false,
  dismiss: () => {}
});

/** Returns true when the early-preview banner is visible */
export function useEarlyPreviewBanner() {
  return useContext(EarlyPreviewContext).isVisible;
}
export function useEarlyPreviewDismiss() {
  return useContext(EarlyPreviewContext).dismiss;
}
export function EarlyPreviewBannerProvider(t0) {
  const $ = _c(9);
  const {
    children
  } = t0;
  const {
    isDismissed,
    hasLoaded,
    dismiss
  } = useDismissible(BANNER_DISMISSED_KEY);
  const isVisible = hasLoaded && !isDismissed;
  let t1;
  if ($[0] !== dismiss || $[1] !== isVisible) {
    t1 = {
      isVisible,
      dismiss
    };
    $[0] = dismiss;
    $[1] = isVisible;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isVisible) {
    t2 = isVisible && <EarlyPreviewBanner />;
    $[3] = isVisible;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== t1 || $[7] !== t2) {
    t3 = <EarlyPreviewContext.Provider value={t1}>{t2}{children}</EarlyPreviewContext.Provider>;
    $[5] = children;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}